<template>
  <v-data-table
    :items="items"
    :headers="tblHeaders"
    disable-pagination
    hide-default-footer
  >
    <template v-if="items.length > 0" v-slot:body="{ items }">
      <tbody>
        <tr v-for="item in items" :key="item._id">
          <td :colspan="item.tp == 'material' ? 1 : ((item.tp == 'final' || item.tp == 'catFinal') ? 4 : 5)">
            <template v-if="item.tp == 'cat'"><h3>{{ item.name }}</h3></template>
            <template v-else-if="item.tp == 'final' || item.tp == 'catFinal'">
              <div style="text-align: right;">
                <strong>{{ item.name }}</strong>
              </div>
            </template>
            <template v-else>
              <material-card :product="item" :hideSelect="true"></material-card>
            </template>
          </td>
          <td v-if="item.tp == 'material'">
            {{ item.unitName == item.productUnitName ? item.unitName : 
              `${item.productUnitName} (${item.productUnitSize} ${item.unitName})` }}
          </td>
          <td v-if="item.tp == 'material'">
            {{ item.pricePerUnit }}
          </td>
          <td v-if="item.tp == 'material'">
            {{ item.value.toFixed(2) }}
          </td>
          <td v-if="item.tp == 'material' || item.tp == 'final' || item.tp == 'catFinal'">
            {{ item.cost.toFixed(2) }}
          </td>
        </tr>
      </tbody>
    </template>
  </v-data-table>
</template>

<script>
import MaterialCard from '../constructor/constructor_materials/ConstructorMaterialCard';

export default {
  props: {
    price: Object,
    materials: Array
  },

  components: {
    MaterialCard
  },

  data() {
    return {
      tblHeaders: [
        {
          text: 'Наименование',
          value: 'id'
        },
        {
          text: 'Ед.изм',
          value: 'unit'
        },
        {
          text: 'Цена за ед.',
          value: 'pricePerUnit'
        },
        {
          text: 'Кол-во',
          value: 'value'
        },
        {
          text: 'Стоимость',
          value: 'cost'
        }
      ]
    }
  },

  computed: {
    items() {
      let materialsList = this.materials.map(mat => {
        let item = this.price.materials.find(x => x.name == mat.original);
        if (item) {
          return {
            ...item,
            value: mat.value,
            cost: mat.value * item.pricePerUnit,
            categoryName: this.price.materialCategories.find(x => x._id == item.category).name
          }
        } else {
          console.log('Материал не найден: ' + mat.original);
          return {};
        }
      });
      let items = [];
      let prev = null;
      for (let mat of materialsList) {
        if (!prev || prev.category != mat.category) {
          if (prev) {
            items.push({
              tp: 'catFinal',
              name: `ИТОГО (${prev.categoryName}):`,
              cost: materialsList.filter(x => x.category == prev.category).reduce((sum, cur) => sum + cur.cost, 0)
            });
          }
          items.push({
            tp: 'cat',
            name: mat.categoryName.toUpperCase()
          });
        }
        items.push({
          tp: 'material',
          ...mat
        });
        prev = mat;
      }
      if (prev) {
        items.push({
          tp: 'catFinal',
          name: `ИТОГО (${prev.categoryName}):`,
          cost: materialsList.filter(x => x.category == prev.category).reduce((sum, cur) => sum + cur.cost, 0)
        });
        items.push({
          tp: 'final',
          name: 'ИТОГО (ПО ВСЕМ КАТЕГОРИЯМ):',
          cost: materialsList.reduce((sum, cur) => sum + cur.cost, 0)
        });
      }
      
      return items;
    }
  }
}
</script>